import axios from 'axios';
import store from '../store';
import Cache from '@/utils/cache';
import Config from '@/utils/config';
import API from './api';

const resetMessage = require('../utils/resetMessage');
const Message = resetMessage.message;

// let serveUrl = 'http://172.21.199.44:32331'; // 吴宇飞本地
let serveUrl = 'http://117.71.53.199:59301/digital-dashboard-service'; // 测试环境
// let serveUrl = 'http://119.3.153.193:50034'; // 生产环境

let baseURL =
  process.env.VUE_APP_BASE_URL === 'serve'
    ? serveUrl
    : process.env.VUE_APP_BASE_URL;
// 创建 axios 实例
const instance = axios.create({
  baseURL, // 请求地址前缀，将自动加在 url 前面
  timeout: 10000, // 请求超时时间
});
let requestUrls = []; // 请求数量

// axios请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = Cache.get(Config.TOKEN); // token
    const staffId = Cache.get(Config.STAFFID);
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    if (config.url.indexOf('/upload') > -1) {
      config.headers['Content-Type'] = 'multipart/form-data';
      config.timeout = 0;
    } else {
      requestUrls.push(config.url);
      if (!config.notLoading)
        store.dispatch('app/showFullLoading', '数据加载中'); // 打开fullLoading
    }
    config.headers['Auth-Type'] = 'STAFF';
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Access-Control-Allow-Credentials'] = true;
    config.headers['timestamp'] = new Date().getTime();
    config.headers.Authorization = token;
    config.headers.staffId = staffId;
    return config;
  },
  (error) => Promise.reject(error),
);

// 状态码判断
const errorHandle = ({ status, data: { message } }) => {
  switch (status) {
    case 404:
      Message.error('404错误，请求的资源不存在');
      break;
    case 500:
      Message.error('500错误，服务器内部错误');
      break;
    default:
      if (message) {
        Message.error(message);
      } else {
        Message.error('服务器错误');
      }
      break;
  }
};

// axios响应拦截器
instance.interceptors.response.use(
  async (res) => {
    requestUrls.forEach((i, index) => {
      if (i === res.config.url) {
        requestUrls.splice(index, 1);
      }
    });
    setTimeout(() => {
      if (requestUrls.length === 0) {
        store.dispatch('app/closeFullLoading'); // 关闭fullLoading
      }
    }, 100);
    if (res.data.success) {
      return res.data;
    } else {
      if (res.data.errCode === '6001') {
        const refreshRes = await instance.post(API.refresh_token_post, {
          jwtTokenExpire: 1800,
          refreshToken: Cache.get(Config.REFRESH_TOKEN),
        });
        if (refreshRes?.success && refreshRes?.data) {
          Cache.set(Config.TOKEN, refreshRes.data.jwtToken);
          Cache.set(Config.REFRESH_TOKEN, refreshRes.data.refreshToken);
          const { url, data } = res.config;
          return await instance.post(url, JSON.parse(data));
        } else {
          Message.warning('身份验证已过期，请重新登录哦~');
          store.dispatch('app/loginOutNoFetch');
        }
      } else {
        Message.error(res.data?.message || '系统内部错误');
        return null;
      }
      // return Promise.reject(res.data);
    }
  },
  (error) => {
    console.log(error);
    if (error.message.includes('timeout')) {
      Message.error('请求超时');
    } else if (error.code === 'ERR_CANCELED') {
      Message.error(error.message || '请求错误');
    } else {
      if (error.response && error.response.data) {
        errorHandle(error.response);
      } else {
        Message.error('请求错误');
      }
    }

    requestUrls.forEach((i, index) => {
      if (i === error.config.url) {
        requestUrls.splice(index, 1);
      }
    });
    setTimeout(() => {
      if (requestUrls.length === 0) {
        store.dispatch('app/closeFullLoading'); // 关闭fullLoading
      }
    }, 100);
    return Promise.reject(error);
  },
);

export default instance;
